enum ROUTES {
  HOME = '/',
  REPORTS = '/reports',
  ACCOUNTS = 'accounts',
  FEEDBACK = 'feedback',
  LOGIN = '/login',
  EDLINK_LOGIN = '/edlink_login',
  LOGOUT = '/logout',
  SURVEY_PAGE = '/surveys',
  PUBLIC_SURVEY_PAGE = '/public/surveys',
  SURVEY_COMPLETED = '/survey_completed',
  ADMIN_PATH = '/admin/',
  ADMIN_REPORTS = '/admin/reports',
  SETTINGS = '/admin/settings',
  USERS = '/admin/users',
  FACULTY_AND_STAFF = '/admin/faculty_and_staff',
  TASKS = '/admin/tasks',
  KITCHEN = '/admin/kitchen',
  STUDENTS = '/admin/students',
  PERMISSION_MANAGEMENT = '/admin/permission_management',
  INSTITUTION_SETTINGS = '/admin/institution_settings',
  REPORTING_HIERARCHY = '/admin/reporting_hierarchy',
  ACADEMIC_UNITS = '/admin/academic_units',
  SURVEYS = '/admin/surveys',
  SURVEY_LIST = '/admin/survey_list',
  DISTRIBUTION_SERIES = '/admin/distribution_series',
  COURSE_AND_ENROLLMENT = '/admin/distribution_series/courses_and_enrollment',
  EMAIL = '/admin/emails',
  SIS_SYNC_LOGS = '/admin/sis_sync_logs',
  SIS_SYNC_RUN_DETAILS = '/admin/sis_sync_logs/:runId',
  STUDENT_SURVEYS = '/student/surveys',
  INSTRUCTOR_SURVEYS = '/instructor/surveys',
  TERMS = '/admin/terms',
  COURSE_CATALOG = '/admin/course_catalog',
  PERMISSION_DENIED = '/permission_denied',
  NOT_FOUND = '/not_found',
  TERMS_DETAILS = '/admin/terms/terms_details',
  EMAIL_SETTINGS = '/admin/email_settings',
  ATTRIBUTES = '/admin/attributes',
  QR_CODE = '/admin/qr_code',
  SURVEY_PREVIEW = '/admin/survey_preview',
  ADMIN_VIEWER_DASHBOARD = '/admin/dashboard',
  ACADEMIC_UNIT_ADDED_QUESTIONS = '/admin/instructor_and_academic_added_questions',
  SURVEY_COMPLETED_PUBLIC = '/public/survey_completed',
  PUBLIC_SURVEY = '/public/surveys',
  SAVED_COMMENTS = '/instructor/saved_comments'
}

export default ROUTES
